// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".horizontal-diff .diff-content li>div{flex:1;display:flex}", ""]);
// Exports
module.exports = exports;
